var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOldPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 3.33333H8.33268",
    stroke: "#A5A6BB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 9.99935H9.33268",
    stroke: "#A5A6BB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66644 3.33398V7.33398L11.1164 11.5803C11.4704 12.0159 11.1604 12.6673 10.599 12.6673H1.40035C0.83899 12.6673 0.52895 12.0159 0.882944 11.5803L4.3331 7.33398V3.33398",
    stroke: "#A5A6BB",
    strokeWidth: 0.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.99935,
    cy: 1.66732,
    rx: 0.333333,
    ry: 0.333333,
    fill: "#A5A6BB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.99935,
    cy: 0.333333,
    rx: 0.333333,
    ry: 0.333333,
    fill: "#A5A6BB"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.33268,
    cy: 2.00065,
    rx: 0.666667,
    ry: 0.666667,
    fill: "#A5A6BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldPartner);
export default __webpack_public_path__ + "static/media/old-partner.770ad31f33425689fbd2d26a2fdd316a.svg";
export { ForwardRef as ReactComponent };